

/**
 * xo-tracking encapsulates all the details about instrumentation
 * and only register event listeners during bootstrap
 *
 */

define(['angular', './listener', './directive'], function (angular) {

    // Declare the dependency to register the listeners
    return angular.module('tracking', ['tracking.listener', 'tracking.directive']);
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-tracking/dist/index.js
// module id = ./components/xo-tracking/dist/index.js
// module chunks = 1